import React from 'react';
import {ProductLineItemDataHook} from '../../ProductLineItemBase';
import TagSmall from 'wix-ui-icons-common/on-stage/TagSmall';
import {st, classes} from './Discounts.st.css';
import {useOrderDiscounts} from '../../../../hooks/useOrderDiscounts';

export interface DiscountsProps {
  lineItemId?: string | null;
  className?: string;
}

export const Discounts = ({lineItemId, className}: DiscountsProps) => {
  const {lineItemDiscounts} = useOrderDiscounts();

  if (!lineItemId || !lineItemDiscounts[lineItemId]?.length) {
    return null;
  }

  return (
    <div className={st(classes.root, className)} data-hook={ProductLineItemDataHook.Discounts}>
      {lineItemDiscounts[lineItemId].map((discount, index) => (
        <div
          className={classes.discountLine}
          key={`line-item-${lineItemId}-discount-${index}`}
          data-hook={ProductLineItemDataHook.Discount}>
          <TagSmall className={classes.discountIcon} />
          <span>{discount.label}</span>
        </div>
      ))}
    </div>
  );
};

Discounts.displayName = 'ProductLineItem.Discounts';
